import { useState, useMemo } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitleDefault from '../default/DialogTitleDefault';
import { Box, Divider, Grid, Typography, TextField } from '@mui/material';
import { ButtonBasic, SelectLugaresCalendar } from '../../components';
import CalendarioV2Service from '../../services/calendarioV2.service';
import { toast } from 'react-toastify';

const ModalEditTareaCalendario = ({show, hideModal, item, traerTareas, ticketId}) => {
    const [isLoading, setIsLoading] = useState(false);
    const handleClose = () => hideModal();
    const [formAll, setFormAll] = useState({
        localidad: item?.lugarId_t || item?.lugarId || '',
        latitud: item?.clienteLatitud_t?.toString() || item?.clienteLatitud?.toString() || '',
        longitud: item?.clienteLongitud_t?.toString() || item?.clienteLongitud?.toString() || '',
        direccion: item?.clienteDireccion_t?.toString() || item?.clienteDireccion?.toString() || '',
    });
    const onSubmit = async() => {
        setIsLoading(true);
        const formSend = {
            ...formAll,
            id: item?.id_t || item?.id,
            dataOld: {
                localidad: item?.lugarId_t || item?.lugarId || '',
                latitud: item?.clienteLatitud_t?.toString() || item?.clienteLatitud?.toString() || '',
                longitud: item?.clienteLongitud_t?.toString() || item?.clienteLongitud?.toString() || '',
                direccion: item?.clienteDireccion_t?.toString() || item?.clienteDireccion?.toString() || '',
            },
        }
        await CalendarioV2Service.editarTareaCalendar(formSend).then((resp)=>{
            setIsLoading(false);
            if(resp?.status){
                toast.success('Tarea editada con éxito.', {
                    position: "top-right",
                    autoClose: 3500,
                    pauseOnHover: false,
                });
                traerTareas();
                handleClose();
            }
        }).catch((e)=>{
            setIsLoading(false);
            console.log({e})
        });
    }
    const styleInputHeight = useMemo(() => ({
        '& .MuiInputLabel-root':{
          color: 'gray',
          fontSize: 15
        },
        '& fieldset': {
            borderRadius: 2,
            border: 1,
            borderColor: 'gray',
            height: 45
        },
        '& label':{
          marginTop: -0.5,
        },
        '& .MuiOutlinedInput-root': {
          '&.Mui-focused fieldset': {
            border:1,
            height: 45,
            color: '#000'
          },
          '&:hover':{
            border: 1,
            borderRadius: 2,
            borderColor: 'gray',
            height: 40
          },
          '&.Mui-focused': {
            '&:hover':{
              border:0,
              height: 40
            }
          },
          color: 'gray',
          height: 40
        }
    }), [])
    return(
        <Dialog open={show} disableEscapeKeyDown maxWidth='xs' fullWidth sx={{backdropFilter: 'blur(0.4px);'}}>
            <Box sx={{background: '#fff'}}>
                <DialogTitleDefault id="add-canal-priv" onClose={handleClose}>
                    <Typography sx={{flex:1,textAlign: 'center', color: '#000',fontWeight: 'bold'}} variant='h5'>
                        Cambiar datos de la tarea
                    </Typography>
                </DialogTitleDefault>
                <Divider sx={{background: 'gray'}} />
                <DialogContent>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sx={{mt:2, mb:0}}>
                            <Box sx={{display: 'flex', flexDirection: 'row'}}>
                                <Typography sx={{color: '#000',fontWeight: 'bold'}} component='div'>
                                    (*) <Box sx={{fontWeight: 'normal',display: 'inline' }}>Localidad calendario</Box>
                                </Typography>
                            </Box>
                            <SelectLugaresCalendar
                                value={formAll.localidad}
                                isInvalid={!formAll.localidad}
                                onChange={(e)=>{
                                    setFormAll({...formAll, localidad: e.value});
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Box sx={{display: 'flex', flexDirection: 'row'}}>
                                <Typography sx={{color: '#000',fontWeight: 'bold'}} component='div'>
                                    (*) <Box sx={{fontWeight: 'normal',display: 'inline' }}>Dirección</Box>
                                </Typography>
                            </Box>
                            <TextField
                                fullWidth
                                autoComplete='off'
                                sx={styleInputHeight}
                                value={formAll?.direccion}
                                onChange={(e)=>setFormAll({...formAll, direccion: e.target.value})}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Box sx={{display: 'flex', flexDirection: 'row'}}>
                                <Typography sx={{color: '#000',fontWeight: 'bold'}} component='div'>
                                    (*) <Box sx={{fontWeight: 'normal',display: 'inline' }}>Latitud</Box>
                                </Typography>
                            </Box>
                            <TextField
                                fullWidth
                                autoComplete='off'
                                sx={styleInputHeight}
                                value={formAll?.latitud}
                                onChange={(e)=>setFormAll({...formAll, latitud: e.target.value})}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Box sx={{display: 'flex', flexDirection: 'row'}}>
                                <Typography sx={{color: '#000',fontWeight: 'bold'}} component='div'>
                                    (*) <Box sx={{fontWeight: 'normal',display: 'inline' }}>Longitud</Box>
                                </Typography>
                            </Box>
                            <TextField
                                fullWidth
                                autoComplete='off'
                                sx={styleInputHeight}
                                value={formAll?.longitud}
                                onChange={(e)=>setFormAll({...formAll, longitud: e.target.value})}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <Divider sx={{background: 'gray'}} />
                <DialogActions sx={{display:'flex', justifyContent:'center'}}>
                    <ButtonBasic
                        textButton='Cancelar'
                        variant='wk'
                        color='cancel'
                        onClick={()=>handleClose()}
                        isLoading={isLoading}
                    />
                    <ButtonBasic
                        textButton='Guardar'
                        onClick={()=>onSubmit()}
                        isLoading={isLoading}
                        isDisabled={!formAll.localidad || !formAll.latitud || !formAll.longitud || !formAll.direccion || isLoading}
                        variant='wk'
                        color='nextStep'
                    />
                </DialogActions>
            </Box>
        </Dialog>
    )
}

export default ModalEditTareaCalendario;